<template>
  <div
    :id="application.id"
    class="purchase-card"
    :class="{'mb-4': !last}">
    <div class="flex">
      <div class="py-0 pr-6 pt-1 col-7">
        <router-link
          :to="application.status != 'П' ? { name:'purchitem', params: {id: application.id ,org: $route.params.org }}
            : {name: 'editing', query: {id : application.id}, params: {org: $route.params.org}}">
          <div
            class="pa-0 pb-5  h3-headline text-start">
            {{ `#${application.number}.  (${application.title || $t('Catalog.NewPurchase')})` }}
          </div>
        </router-link>
        <div class="card-text pa-0">
          <div
            class="flex pb-4">
            <KeyValue
              :caption="$t('Purchasing.DeliveryDate')"
              class="pr-3 info-cols">
              <DateSpan :item="application"/>
            </KeyValue>
            <KeyValue
              :caption="$t('Purchasing.Sum')"
              class="pr-3 info-cols">
              <span
                v-if="application.summa"
                style="">
                {{ formSum(application.summa) }}
                {{ getCurrencyName(application, application.summa ) }}
              </span>
              <span
                v-else> – </span>
            </KeyValue>
            <KeyValue
              :caption="$t('Application.WhoCreated')"
              class="pr-3 info-cols">
              <div
                class="flex flex-wrap align-center"
                style="white-space: nowrap;">
                <PersonTooltip :item="application.creatorObject "/>
              </div>
              <div class="creation-date h8-text pb-1">
                {{ dateStr }}
              </div>
            </KeyValue>
          </div>
          <div>
            <div
              v-for="(item , n) in application.rows.slice(0, 2)"
              :key="n"
              data-qa="1234">
              {{ item || $t('Common.NoData') }}
            </div>
            <div
              v-if="application.rows.length > 2"
              class="h7-text">
              {{ `+ ${application.rows.length - 2} ${$t('Purchasing.Positions')}` }}
            </div>
          </div>
        </div>
      </div>
      <div class="actions-container">
        <div
          class="flex flex-right">
          <div
            class="status-block"
            style="width: 245px">
            <template v-if="application.statusId">
              <KeyValue
                :caption="$t('Purchasing.Status')"
                class="mb-1">
                <StatusChip
                  class="mb-2"
                  key-name="id"
                  name="name"
                  :status="status"/>
              </KeyValue>
              <KeyValue
                v-if="!$can('have', 'AgreementsProcess')"
                :caption="$t('Purchasing.Approval')">
                <div
                  class="flex align-center">
                  <ListOfAcceptors
                    :acceptors="application.acceptors"
                    :item="application"
                    with_loading/>
                </div>
              </KeyValue>
            </template>
            <ListOfAcceptors
              v-else
              :acceptors="application.acceptors"
              :item="application"/>
          </div>
          <sPopover
            placement="bottom-end"
            trigger="click"
            width="200">
            <sButton
              slot="reference"
              icon="menu"
              small
              type="text"/>
            <div
              class="purch-card-menu menu">
              <CopyItem
                :copy-item="$_copyApp"
                list/>
              <ToggleTemplates
                :add="!application.inTemplates"
                list
                @click="toggleTemplate"/>
              <MenuItem
                v-if="application.status == 'П'"
                data-qa="purchase-remove"
                icon="delete"
                :label="$t('Purchasing.Remove')"
                @click="removeApp"/>
            </div>
          </sPopover>
        </div>
        <div
          v-if="application.status != 'П' "
          class="purchase-card__comments">
          <CommentsCountBtn
            :comments_length=" 0"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MenuItem from 'components/common/MenuItem.vue'
import KeyValue from 'components/common/KeyValue.vue'
import DateSpan from 'components/common/elements/DateSpan.vue'
import CopyItem from 'components/common/elements/CopyItem.vue'
import StatusChip from 'components/common/elements/StatusChip.vue'
import PersonTooltip from 'components/common/blocks/PersonTooltip.vue'
import ListOfAcceptors from 'components/agreement/ListOfAcceptors.vue'
import ToggleTemplates from 'components/common/elements/ToggleTemplates.vue'
import CommentsCountBtn from 'components/common/elements/CommentsCountBtn.vue'

import { filterSortMixin, applicationMixin, modalMixin } from 'mixins'

import moment from 'moment'
export default {
  name: 'purchaseCard',
  mixins: [ filterSortMixin, applicationMixin , modalMixin],
  data() {
    return {
      comments: [],
    }
  },
  props: {
    filter_type: String,
    application: {
      type: Object,
      required: true
    },
    last: Boolean,
    loading: Boolean,
  },
  computed: {
    statuses() {
      return this.$store.state.config.statuses
    },
    dateStr() {
      return this.formatDate(this.application.creationDate)
    },
    status( ) {
      return  this.statuses?.find(el => el.id == this.application.statusId) || {
        id: this.application.statusId,
        name: '-'
      }
    },
    acceptors() {
      return this.application.acceptors
    },
  },
  methods: {
    formatDate(value) {
      if (value) {
        return moment(value).calendar()
      }
    },
  },
  components: {
    KeyValue,
    MenuItem,
    DateSpan,
    CopyItem,
    StatusChip,
    PersonTooltip,
    ToggleTemplates,
    ListOfAcceptors,
    CommentsCountBtn,
  }
}
</script>
<style lang="scss" scoped>
.purchase-card {
  background-color: var(--v-main__light_green-base);
  border-color: var(--v-main__light_green-base);
  padding-right: 32px;
  padding-left: 32px;
  padding-bottom: 24px;
  padding-top: 24px;
  &__comments {
    display: flex;
    justify-content: flex-end;
  }
}
.card-actions {
  max-height: 40px;
  .v-icon{
    color: var(--black-color);
  }
}
.card-text {
  text-align: start;
  font-size: 14px;
  .info-cols {
    flex-grow: 1;
    max-width: 165px;
    &:nth-child(3) {
      max-width: 200px;
    }
  }
  .creation-date {
    text-transform: unset;
  }
}
.card-title {
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.002em;
}

img {
  min-width: 16px !important;
  width: 16px !important;
  min-height: 16px !important;
  height: 16px !important;
}
.actions-container {
  position: relative;
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
  font-size: 14px;
  line-height: 22px;
}
.subheader {
  text-transform: uppercase;
}
.responsible span {
  font-size: 12px;
  line-height: 13px;
  // height: 16px;
  letter-spacing: 0.002em;
  color: var(--text-color);
}

.status-block {
  flex-direction: column;
}

</style>
<style lang="scss">
.purch-card-options-menu {
  box-shadow: none;
  .v-list-item {
    min-height: 35px;
  }
  .v-list-item__title {
    font-size: 12px !important;
    letter-spacing: 0.02em ;
    text-transform: uppercase;
  }
  .v-list-item__icon {
    min-width: 16px !important;
    width: 16px !important;
    min-height: 16px !important;
    height: 16px !important;
  }
}
</style>
